export default defineNuxtRouteMiddleware(async (to, from) => {
  globalThis.$logger.info(
    'useAppRunningStore :: isRunning',
    useAppRunningStore().isRunning
  );
  const openDB = to.meta.openDB != null ? to.meta.openDB : true;
  const appRunning = useAppRunningStore();
  if (openDB) {
    await appRunning.start();
  } else if (appRunning.isRunning) {
    return appRunning.forceStop();
  }
});
